<template>
  <div class="page_bg">
    <div class="bgfff plr20 pt30 pb30 flex_between mb20">
      <div>
        <div>{{ user.username }}</div>
      </div>
      <div class="red" @click="logOut">退出</div>
    </div>
    <div class="flex_items flex_between plr20 bgfff pt30 pb30" @click="$router.push('/projectSetting')">
      <div class="flex_items flex"><van-icon name="points" class="mr10" size="24" /> 积分</div>
      <van-icon name="arrow" />
    </div>
		<div class="flex_items flex_between plr20 bgfff pt30 pb30" @click="$router.push('/rolelist')">
		  <div class="flex_items flex"><van-icon name="setting-o" class="mr10" size="24" /> 账号管理</div>
		  <van-icon name="arrow" />
		</div>
    <div class="flex_items flex_between plr20 bgfff pt30 pb30" @click="handleFn">
		  <div class="flex_items flex"><van-icon name="edit" class="mr10" size="24" /> 修改密码</div>
		  <van-icon name="arrow" />
		</div>
    <Popup v-model="show">
      <changeUserPassw @closeFn="show = false"  @successFn="logOut"></changeUserPassw>
    </Popup>
  </div>
</template>
<script>
import { Popup } from "vant";
import changeUserPassw from "@/components/changeUserPassw";
export default {
  components: {
    Popup,changeUserPassw
  },
  data() {
    return {
      user: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user"))
        : {},
      show:false,
    };
  },
  created() {},
  methods:{
    logOut(){
      localStorage.removeItem('user')
      localStorage.removeItem('token')
      this.$router.push('/login')
    },
    handleFn(){
      this.show = true;
    }
  }
};
</script>
